
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/ralali-partner",
      function () {
        return require("private-next-pages/services/ralali-partner/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/ralali-partner"])
      });
    }
  